exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-themed-secondary[data-v-8c4b37b0]{padding:7px 14px;text-transform:none;border-radius:6px}.btn-kaspi[data-v-8c4b37b0]{background:#f14635;color:#fff;line-height:40px;display:block;text-align:center;border-radius:6px}.btn-kaspi[data-v-8c4b37b0]:hover{text-decoration:none}.btn-kaspi img[data-v-8c4b37b0]{position:relative;top:-2px;left:4px}", ""]);

// exports
